"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withUnauthorized = withUnauthorized;
const redirects_1 = require("../redirects");
async function withUnauthorized(callback, context) {
    try {
        const response = await callback(context);
        return response;
    }
    catch (e) {
        if (e?.response?.status === 401) {
            context.res.setHeader("set-cookie", "jwt=; Path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;");
            return (0, redirects_1.createRedirect)("/", false)(context);
        }
        return Promise.reject(e);
    }
}
//# sourceMappingURL=auth.js.map